import { Card, Col, Row } from "antd";
import type { Event } from "../../../types/events";
import dayjs from "dayjs";
import spacing from "../../../components/ui/spacingConfig";

type Props = {
  eventData: Event | undefined;
  className?: string;
};

const CardDatePlace: React.FC<Props> = ({ eventData, className }) => {
  return (
    <Card title="Date et lieu" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Site</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{eventData?.site?.name}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">PrÃ©cision</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{eventData?.localisation}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de la dÃ©claration</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {eventData?.dateCreated
              ? dayjs(eventData.dateCreated).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de l'Ã©vÃ©nement</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {eventData?.dateEvt
              ? dayjs(eventData.dateEvt).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDatePlace;
